module.exports = __webpack_public_path__ + "static/media/photo270.a0a408c9.jpg";